import React, {useMemo} from "react"
import PropTypes from "prop-types"
import {DesktopDatePicker} from "@mui/x-date-pickers"
import moment from "moment"
import {Box, Typography} from "@mui/material"
import InfoIcon from "../../components/general/infoIcon"

const momentToIsoYear = mom => mom.format("YYYY")
const momentToIsoDate = mom => mom.format("YYYY-MM-DD")

const selectIso = (momentObj, isFullDate) => isFullDate ? momentToIsoDate(momentObj) : momentToIsoYear(momentObj)

export const widgetYearPickerPrototype = [
    {
        "key": "isFullDate",
        "type": "YESNO",
        "label": "Full Date Variante",
        "size": 6,
    },
    {
        "key": "infotext",
        "type": "STRING",
        "label": "infotext",
        "size": 6,
    },
]


const YearPicker = ({
                        widget,
                        onValueChange,
                        onBlur,
                        selectOnFocus,
                        onFocus,
                        value,
                        disabled,
                        className,
                        label,
                        id,
                        error,
                    }) => {

    const {isFullDate = false} = widget

    const localOnChange = momentObj => {
        if (onValueChange) {
            momentObj?.isValid()
                ? onValueChange(selectIso(momentObj, isFullDate))
                : onValueChange(null, el => el, [])
        }
    }

    const localOnBlur = event => {
        if (onBlur) {
            onBlur(moment(event.target.value, "YYYY"), momentToIsoYear)
        }
    }

    const localOnFocus = event => {
        if (selectOnFocus) {
            event.target.select()
        }
        if (onFocus) {
            onFocus(event)
        }
    }

    const defaultVal = useMemo(() => {
        if (value) {
            return moment(value?.toString()?.length === 4 ? `${value}-01-01` : value)
        } else {
            return null
        }
    }, [value])

    return (
        <Box>
            {widget.text && (
                <Box display="flex">
                <Typography className={disabled ? "disabled" : ""}>
                    {widget.text}
                </Typography>
                    {widget.infotext && <InfoIcon infoText={widget.infotext} />}
                </Box>
            )}
            <DesktopDatePicker
                label={label}
                id={id}
                value={defaultVal}
                onChange={localOnChange}
                onBlur={localOnBlur}
                onFocus={localOnFocus}
                disabled={disabled}
                className={className}
                views={["year"]}
                slotProps={{
                    textField: {
                        error: error,
                    },
                }}
            />
        </Box>
    )
}

YearPicker.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
}

export default YearPicker
